import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import FlexBox from '../common/FlexBox'
import SearchInput from '../common/SearchInput'

import { withI18n } from '../../i18n/util'

const SearchWrap = styled(FlexBox)`
  background: ${({ theme }) => theme.exchangeTradePairSearchBg};
  margin: 0 0 10px 0;
  flex-wrap: nowrap;
  height: 30px;
  align-items: center;
`

const Filter = styled.div`
  margin-left: 8px;
  margin-top: 4px;
  color: ${({ theme }) => theme.exchangeTitleColor};
`

const RadioPanelLabel = styled.label`
  cursor: pointer;
  margin-right: 15px;
  user-select: none;
  white-space: nowrap;
  &:hover i {
    box-shadow: inset 0 0 0 4px ${({ theme }) => theme.radioBg};
    background: #888;
  }
`

const RadioPanelInput = styled.input`
  visibility: hidden;
  position: absolute;

  &:checked + i {
    box-shadow: inset 0 0 0 4px ${({ theme }) => theme.radioBg};
    background: ${({ theme }) => theme.highlight};
    border-color: ${({ theme }) => theme.highlight};
  }
`

const RadioPanelIcon = styled.i`
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  box-shadow: inset 0 0 0 8px ${({ theme }) => theme.radioBg};
  border: 1px solid ${({ theme }) => theme.tabBorderColor};
  background: ${({ theme }) => theme.exchangeSecondBg};
  margin-right: 4px;
  margin-top: -2px;
`

class TradingPairFilter extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    formatI18nText: PropTypes.func,
  }

  static defaultProps = {
    onChange: () => {},
    formatI18nText: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      togglePanel: 'change',
      searchKeyWord: '',
    }
  }

  _onTogglePanelChange = ev => {
    if (!ev || !ev.target || !(ev.target instanceof HTMLInputElement)) return
    const { value: togglePanel } = ev.target
    const { searchKeyWord } = this.state
    const { onChange } = this.props
    this.setState({ togglePanel }, () => {
      setTimeout(() => {
        onChange(togglePanel, searchKeyWord)
      })
    })
  }

  _onSearchBarChange = text => {
    const { togglePanel } = this.state
    const { onChange } = this.props
    const searchKeyWord = text.trim().toUpperCase()
    this.setState({ searchKeyWord }, () => {
      setTimeout(() => {
        onChange(togglePanel, searchKeyWord)
      })
    })
  }

  render() {
    const { togglePanel } = this.state
    const { formatI18nText } = this.props

    return (
      <SearchWrap>
        <FlexBox margin="0 0 0 5px" style={{ width: '100px' }}>
          <SearchInput
            placeholder={`${formatI18nText('exchange.tradingPair.search')} …`}
            onChange={this._onSearchBarChange}
            width="100px"
          />
        </FlexBox>
        <Filter>
          <RadioPanelLabel htmlFor="field-change">
            <RadioPanelInput
              type="radio"
              name="togglePanel"
              id="field-change"
              value="change"
              checked={togglePanel === 'change' ? 'checked' : ''}
              onChange={this._onTogglePanelChange}
            />
            <RadioPanelIcon />
            <span>{formatI18nText('exchange.tradingPair.change')}</span>
          </RadioPanelLabel>
          <RadioPanelLabel htmlFor="field-volume">
            <RadioPanelInput
              type="radio"
              name="togglePanel"
              id="field-volume"
              value="volume"
              checked={togglePanel === 'volume' ? 'checked' : ''}
              onChange={this._onTogglePanelChange}
            />
            <RadioPanelIcon />
            <span>{formatI18nText('exchange.tradingPair.volume')}</span>
          </RadioPanelLabel>
        </Filter>
      </SearchWrap>
    )
  }
}

export default withI18n(TradingPairFilter)
